import React, { createContext, useEffect, useState } from "react";
import Banner from "../../main/funnel/Banner/Banner";

import Mentors from "../../main/funnel/Mentors/Mentors";
import WYL from "../../main/funnel/WYL/WYL";
import LearningBenefits from "../../main/funnel/LearningBenefits/LearningBenefits";
import Testimonials from "../../main/funnel/Testimonials/Testimonials";
import FAQ from "../../main/funnel/FAQ/FAQ";
import CourseBundle from "../../main/funnel/CourseBundle/CourseBundle";
import Dialog from "../../main/funnel/dialog/Dialog";
import { useSearchParams } from "react-router-dom";
import MidMain from "../../main/funnel/MidMain/MidMain.jsx";
import ProgramContent from "../../main/funnel/ProgramContent/ProgramContent";
import axios from "axios";
import PopupNotification from "../../utils/Pop/PopUp";
export let MyContext = createContext();

const Funnel = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState({});
  const id = searchParams.get("course_id");
  // To read a specific query parameter  let [state ,setState] = useState([])


  useEffect(() => {
    let fetchCards = async () => {
      let response = await axios.get(
        "https://vercel-deployment-w4ja.onrender.com/api/get_all_cards"
      );
      let filters = response.data.filter((value) => value._id === id);
    
      setState({ color: filters[0].color, razor: filters[0].razorURL });
    };
    fetchCards();
  }, []);
  return (
    <MyContext.Provider value={{ state }}>
       <PopupNotification />
      
      <Banner id={id} state={state} />
      <MidMain id={id} state={state} />
      <Mentors id={id} state={state} />
      <WYL id={id} state={state} />
      <ProgramContent id={id} state={state} />
      <LearningBenefits state={state} />
      <Testimonials id={id} state={state} />
      <Dialog />
      <FAQ />
      <div className="pb-16">

      <CourseBundle id={id} state={state} />
      </div>
      {/* <ContactFormMain/> */}
    </MyContext.Provider>
  );
};

export default Funnel;
